import { find } from 'lodash';
import { countries } from '@nextiva/crm-country-data';
import { parsePhoneNumber } from 'libphonenumber-js';

export const isValidPhoneNumber = ({ code, number }) => {
  try {
    if (number === '') {
      return true;
    }

    const regexLastValueIsDigit = /[\d]$/;

    if (!regexLastValueIsDigit.test(number)) {
      return false;
    }

    const country = find(countries, { code });
    const phoneNumber = parsePhoneNumber(`${code} ${number}`);

    return !!country && phoneNumber.isValid();
  } catch (err) {
    return false;
  }
};
